export const dropDownOpenedEvent = []